<div class="hamburger-container" [class.active]="isVisible">
  <div class="menu-hamburger" [class.default-size]="!!!customIcon" (click)="handleShowHamburgerMenu()">
    @if (customIcon) {
      <ng-container *ngTemplateOutlet="customIcon"></ng-container>
    } @else {
      <div></div>
      <div></div>
      <div></div>
    }
  </div>
  @if (hasElements) {
    <div class="menu-hamburger-elements" [class.active]="isVisible">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  }
</div>

